import { Container } from "react-bootstrap";
import AxpoInvoicesCard from "./dataconfig/AxpoInvoicesCard";
import DailyReportsCard from "./dataconfig/DailyReportsCard";
import DocumentNumbersCard from "./dataconfig/DocumentNumbersCard";
import ExportAllSitesCard from "./dataconfig/ExportAllSitesCard";
import GlobalStateCard from "./dataconfig/GlobalStateCard";
import PVSummaryCard from "./dataconfig/PVSummaryCard";
import SurveyEndpointsCard from "./dataconfig/SurveyEndpointsCard";
import VoaDataLoadedCard from "./dataconfig/VoaDataLoadedCard";

const DataConfig = () => {
  document.title = "Data & Config";

  return (
    <Container
      fluid
      className="d-flex flex-column gap-3"
      style={{ padding: "12px 12px 0px 12px", fontSize: 14 }}
    >
      <DocumentNumbersCard />
      <SurveyEndpointsCard />
      <GlobalStateCard />
      <AxpoInvoicesCard />
      <PVSummaryCard />
      <DailyReportsCard />
      <ExportAllSitesCard />
      <VoaDataLoadedCard />
    </Container>
  );
};

export default DataConfig;
